/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import { loadAuthToken } from "./../../../src/state_management/localStorage";

const axios = require("axios").default;

const http = axios.http;
const https = axios.https;
const Qs = axios.Qs;
const CancelToken = axios.CancelToken;

let default_config = {
  // `url` is the server URL that will be used for the request
  // url: '/user',

  // // `method` is the request method to be used when making the request
  // method: 'get', // default

  // // `baseURL` will be prepended to `url` unless `url` is absolute.
  // // It can be convenient to set `baseURL` for an instance of axios to pass relative URLs
  // // to methods of that instance.
  // baseURL : 'http://3.236.73.36:7002/'
  // baseURL : 'http://3.236.73.36:7006/'
  baseURL: process.env.NODE_ENV === 'development' ? "https://staging.bayestree.com/" : "",
  // baseURL: process.env.NODE_ENV === 'development' ? "https://snapshotonsystestp3.sainapse.ai/" : "", 
  // Staging: 'https://staging.bayestree.com/'
  // Test VM : https://testing.bayestree.com/
  // Demo landscape : 'https://demolandscape.bayestree.com/'
  // Attachment : 'http://3.236.73.36:7002/'
  // // `transformRequest` allows changes to the request data before it is sent to the server
  // // This is only applicable for request methods 'PUT', 'POST', 'PATCH' and 'DELETE'
  // // The last function in the array must return a string or an instance of Buffer, ArrayBuffer,
  // // FormData or Stream
  // // You may modify the headers object.
  // transformRequest: [function (data, headers) {
  //     // Do whatever you want to transform the data

  //     return data;
  // }],
  // transformResponse: [function (data) {
  // // Do whatever you want to transform the data

  // return data;
  // }],

  // // `headers` are custom headers to be sent
  // headers: loadAuthToken() ? { Authorization: loadAuthToken() } : {},

  // // `params` are the URL parameters to be sent with the request
  // // Must be a plain object or a URLSearchParams object
  // params: {
  // ID: 12345
  // },

  // // `paramsSerializer` is an optional function in charge of serializing `params`
  // // (e.g. https://www.npmjs.com/package/qs, http://api.jquery.com/jquery.param/)
  // paramsSerializer: function (params) {
  //     return Qs.stringify(params, {arrayFormat: 'brackets'})
  // },

  // timeout: 1000, // default is `0` (no timeout)

  // // `withCredentials` indicates whether or not cross-site Access-Control requests
  // // should be made using credentials
  // withCredentials: false, // default

  // // `adapter` allows custom handling of requests which makes testing easier.
  // // Return a promise and supply a valid response (see lib/adapters/README.md).
  // adapter: function (config) {
  //     /* ... */
  // },
  // // auth: {
  // //     username: 'janedoe',
  // //     password: 's00pers3cret'
  // // },

  // // `responseType` indicates the type of data that the server will respond with
  // // options are: 'arraybuffer', 'document', 'json', 'text', 'stream'
  // //   browser only: 'blob'
  // responseType: 'json', // default

  // // `responseEncoding` indicates encoding to use for decoding responses
  // // Note: Ignored for `responseType` of 'stream' or client-side requests
  // responseEncoding: 'utf8', // default

  // // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
  // xsrfCookieName: 'XSRF-TOKEN', // default

  // // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
  // xsrfHeaderName: 'X-XSRF-TOKEN', // default

  // // `onUploadProgress` allows handling of progress events for uploads
  // onUploadProgress: function (progressEvent) {
  //     // Do whatever you want with the native progress event
  // },

  // // `onDownloadProgress` allows handling of progress events for downloads
  // onDownloadProgress: function (progressEvent) {
  //     // Do whatever you want with the native progress event
  // },

  // // `maxContentLength` defines the max size of the http response content in bytes allowed
  // maxContentLength: 2000,

  // // `validateStatus` defines whether to resolve or reject the promise for a given
  // // HTTP response status code. If `validateStatus` returns `true` (or is set to `null`
  // // or `undefined`), the promise will be resolved; otherwise, the promise will be
  // // rejected.
  // validateStatus: function (status) {
  //     return status >= 200 && status < 300; // default
  // },

  // // `maxRedirects` defines the maximum number of redirects to follow in node.js.
  // // If set to 0, no redirects will be followed.
  // maxRedirects: 5, // default

  // // `socketPath` defines a UNIX Socket to be used in node.js.
  // // e.g. '/var/run/docker.sock' to send requests to the docker daemon.
  // // Only either `socketPath` or `proxy` can be specified.
  // // If both are specified, `socketPath` is used.
  // socketPath: null, // default

  // // `httpAgent` and `httpsAgent` define a custom agent to be used when performing http
  // // and https requests, respectively, in node.js. This allows options to be added like
  // // `keepAlive` that are not enabled by default.
  // // httpAgent: new http.Agent({ keepAlive: false }),
  // // httpsAgent: new https.Agent({
  // //     keepAlive: false,
  // //     rejectUnauthorized: false
  // // }),

  // // 'proxy' defines the hostname and port of the proxy server.
  // // You can also define your proxy using the conventional `http_proxy` and
  // // `https_proxy` environment variables. If you are using environment variables
  // // for your proxy configuration, you can also define a `no_proxy` environment
  // // variable as a comma-separated list of domains that should not be proxied.
  // // Use `false` to disable proxies, ignoring environment variables.
  // // `auth` indicates that HTTP Basic auth should be used to connect to the proxy, and
  // // supplies credentials.
  // // This will set an `Proxy-Authorization` header, overwriting any existing
  // // `Proxy-Authorization` custom headers you have set using `headers`.
  // proxy: {
  //     host: '',
  //     port: 9000,
  //     auth: {
  //         username: 'mikeymike',
  //         password: 'rapunz3l'
  //     }
  // },

  // // `cancelToken` specifies a cancel token that can be used to cancel the request
  // // (see Cancellation section below for details)
  // cancelToken: new CancelToken(function (cancel) {
  // })
};

let sample_config = {
  url: "/",
  method: "get",
  data: {},
  params : {}
};

//let apiService = axios.create(default_config)

let callApi = (api_config = sample_config) => {
  // console.log("API Request Config :", loadAuthToken());

  //include header for auth token
  let authToken = loadAuthToken();
  if (
    authToken &&
    api_config.url !== "/login" &&
    api_config.url !== "/signup"
  ) {
    default_config.headers = {
      ...default_config.headers,
      ...api_config.headers,
      Authorization: authToken,
      'X-Requested-With': 'XMLHttpRequest'
    };
  }
  let config = { ...default_config, ...api_config, headers : default_config.headers };
  // console.log("API Request Config :", config, loadAuthToken());

  console.log("Node Environment : ", process.env.NODE_ENV)
  return axios({ ...config });
};

export default callApi;